<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Lista de paquetes</h3>
  </div>
  <hr />

  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <div class="input-group">
        <input
          type="text"
          id="table-complete-search"
          name="searchText"
          class="form-control"
          placeholder="Buscar paquete"
          [(ngModel)]="filterText"
          (keyup)="filterRecords()"
        />

        <select
          class="form-select ms-1"
          name="currentOfficeId"
          [(ngModel)]="currentOfficeId"
          id="currentOfficeId"
          (change)="setCurrentOffice($event)"
          *ngIf="rolekey == 'admin'"
        >
          <option value="0" selected="selected">Selecciona sucursal</option>
          <option
            *ngFor="let office of offices"
            value="{{ office.id }}"
            selected="{ office.id == roleofficeid ? 'selected' : '' }"
          >
            {{ office.name }}
          </option>
        </select>

        <button
          class="btn btn-outline-danger ms-1"
          type="button"
          (click)="clearSearch()"
        >
          Limpiar búsqueda
        </button>

        <button
          class="btn btn-outline-primary ms-1"
          type="button"
          (click)="reloadInfo()"
          placement="top"
          ngbTooltip="Refrescar información"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-grip gap-1 d-md-flex justify-content-md-end">
        <a [routerLink]="['/packages/create']" class="btn btn-outline-success">
          <i class="bi bi-plus-circle"></i>
          Crear paquete
        </a>
      </div>
    </div>
  </div>
  <hr />

  <div class="alert alert-success" role="alert" *ngIf="flagDeleted">
    {{ message }}
  </div>

  <form>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="col">Nombre del cliente</th>
          <th class="col">¿Es compartido?</th>
          <th class="col">Precio</th>
          <th class="col">¿Paquete liquidado?</th>
          <th class="col">Total de sesiones</th>
          <th class="col">Fecha de compra</th>
          <th class="col">Acciones</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let pkg of filterPackages">
          <td>
            {{ pkg.client.name }}
            <i
              class="bi bi-question-circle"
              placement="top"
              ngbTooltip="{{ pkg.packageName }} - {{ pkg.type }}"
            ></i>
          </td>

          <td class="text-center">{{ pkg.shared }}</td>
          <td>{{ pkg.subtotal | currency }}</td>
          <td class="text-center">{{ pkg.isOldText }}</td>
          <td class="text-center">{{ pkg.sessionsNumber }}</td>
          <td>{{ pkg.date_purchased }}</td>

          <td>
  <div class="d-flex">
    <a
      [routerLink]="['/packages/edit', pkg.id]"
      [queryParams]="{ page: page }"
      placement="top"
      ngbTooltip="Editar"
      role="button"
      [ngClass]="{ 'link-disabled': pkg.finished }"
      class="btn btn-primary"
    >
      <i class="bi bi-pencil-square"></i>
    </a>

    <a
      class="btn btn-primary ms-2"
      [routerLink]="['/packages/information', pkg.id]"
      [queryParams]="{ page: page }"
      placement="top"
      ngbTooltip="Información"
      role="button"
    >
      <i class="bi bi-person-bounding-box"></i>
    </a>

    <button
      *ngIf="rolekey === 'admin'"
      class="btn btn-danger ms-2"
      (click)="openDeleteMessage(pkg.id, pkg.client.name)"
      placement="top"
      ngbTooltip="Eliminar"
    >
      <i class="bi bi-trash3-fill"></i>
    </button>

    <a
      class="btn btn-primary ms-2"
      [routerLink]="['/packages/advance-payments', pkg.id]"
      [queryParams]="{ page: page }"
      placement="top"
      ngbTooltip="Pago adelantado"
      role="button"
    >
      <i class="bi bi-coin"></i>
    </a>

    <a
      class="btn btn-primary ms-2"
      [routerLink]="['/packages/change-packages', pkg.id]"
      [queryParams]="{ page: page }"
      placement="top"
      ngbTooltip="Transferencia de paquete"
      role="button"
    >
      <i class="bi bi-arrow-left-right"></i>
    </a>

    <a
      (click)="printTicketAgain(pkg.printTicket)"
      placement="top"
      role="button"
      ngbTooltip="Imprimir recibo del paquete"
      class="btn btn-primary ms-2"
    >
      <i class="bi bi-printer"></i>
    </a>
  </div>
</td>
        </tr>
      </tbody>
    </table>
    <div class="text-center mt-2">
      <p>Página {{ page }} de {{ totalPages }}</p>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="page === 1">
            <button
              class="page-link"
              (click)="page > 1 && loadPackages(page - 1)"
            >
              {{ previousLabel || 'Anterior' }}
            </button>
          </li>
          <li
            class="page-item"
            *ngFor="let p of getVisiblePages()"
            [class.active]="page === p"
          >
            <button
              class="page-link"
              (click)="loadPackages(p)"
            >
              {{ p }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="page === totalPages">
            <button
              class="page-link"
              (click)="page < totalPages && loadPackages(page + 1)"
            >
              {{ nextLabel || 'Siguiente' }}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </form>
  <ng-template #modalPackage let-close="close">
    <div class="modal-header">
      <h4 class="modal-title">Eliminar paquete</h4>
      <button class="close" type="button" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        ¿Deseas eliminar el paquete de
        <strong>{{ packageNameDeleted }}</strong>?
      </p>
      <div class="row">
        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
          <button
            type="button"
            (click)="deletePackages(idDeleted)"
            class="btn btn-outline-success"
          >
            Confirmar
          </button>
          <button class="btn btn-outline-danger" type="button" (click)="close()">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
